import { MasterConsultaFundosComponent } from '@app/features/master/consulta-fundos/master-consulta-fundos.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CoreComponentsModule } from '@app/core/components/core-components.module';
import { SharedModule } from '@shared/shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { ComponentsModule } from '../components/components.module';
import { MasterHomeCreateProfileService } from '../master/master-create-profile/service/master-home-create-profile.service';
import { DialogCreateUser } from './create-user/custom-components/dialog.component';
import { MasterBOConsultaProfileComponent } from './master-bo-consulta-perfil/master-bo-consulta-perfil.component';
import { MasterClienteConsultaUsuarios } from './master-cliente-consulta-usuarios/master-cliente-consulta-usuarios.component';
import { MasterConsultaProfileComponent } from './master-consulta-perfil/master-consulta-perfil.component';
import { TableAssociateProfileUser } from './master-create-profile/custom-components/table-associate-profile-user/table-associate-profile-user.component';
import { TableConfirmUsers } from './master-create-profile/custom-components/table-confirm-users/table-confirm-users.component';
import { TableCreateProfile } from './master-create-profile/custom-components/table-create-profile/table-create-profile.component';
import { MasterHomCreateProfileComponent } from './master-create-profile/master-home-create-profile.component';
import { MasterCreateProfileComponent } from './master-create-profile/views/permissoes/master-create-profile.component';
import { MasterCreateProfileUsersComponent } from './master-create-profile/views/usuarios/master-create-profile-users.component';
import { TablePerfilAcesso } from './perfil-acesso/table-perfil-acesso/table-perfil-acesso.component';
import { MasterVisualizarClienteComponent } from './visualizar-cliente/master-visualizar-cliente.component';
import { MasterVisualizarClienteService } from './visualizar-cliente/master-visualizar-cliente.service';
import { MasterVisualizarPerfilPermissoesComponent } from './visualizar-perfil/master-visualizar-perfil-components/master-visualizar-perfil-permissoes/master-visualizar-perfil-permissoes.component';
import { MasterVisualizarPerfilUsuariosComponent } from './visualizar-perfil/master-visualizar-perfil-components/master-visualizar-perfil-usuarios/master-visualizar-perfil-usuario.component';
import { MasterVisualizarPerfilComponent } from './visualizar-perfil/master-visualizar-perfil.component';

import { CriarGruposDeInvestimentoComponent } from './criar-grupos-de-investimento/criar-grupos-de-investimento.component';

import { EditarGrupoDeInvestimentoComponent } from './editar-grupo-de-investimento/editar-grupo-de-investimento.component';
import { MasterConsultaGruposComponent } from './consulta-grupos-investimento/master-consulta-grupos.component';
import { MasterMensagemDeletarComponent } from './consulta-grupos-investimento/custom-components/mensagem-deletar/master-mensagem-deletar.component';
import { MasterMensagemDuplicarComponent } from './consulta-grupos-investimento/custom-components/mensagem-duplicar/master-mensagem-duplicar.component';
import { ClienteModule } from './master-cliente/cliente.module';
import { MasterEditarPerfilAcessoComponent } from './editar-perfil-acesso/master-editar-perfil-acesso.component';
import { MasterEditarPerfilCancelamentoComponent } from './editar-perfil-acesso/custom-components/mensagem-cancelamento/master-editar-perfil-cancelamento.component';
import { MasterEditarPerfilDuplicacaoComponent } from './editar-perfil-acesso/custom-components/messagem-duplicacao/master-editar-perfil-duplicacao.component';
import { MasterBoPerfilAcessoComponent } from '../master-bo-perfil-acesso/master-bo-perfil-acesso.component';
import { MasterBoTablePerfilAcesso } from '../master-bo-perfil-acesso/master-bo-table-perfil-acesso/master-bo-table-perfil-acesso.component';
import { MasterTableProfile } from './master-consulta-perfil/custom-components/table-profile.component';
import { TableProfile as TableProfile2 } from './master-bo-consulta-perfil/custom-components/table-profile.component';
import { MasterClienteVisualizarClienteComponent } from './master-cliente-visualizar-cliente/master-cliente-visualizar-cliente.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material';


/**
 *  Custom feature module used to declare custom modules, components, services ....
 *  This file will not be deleted or overwritten by Palmyra Generator
 *
 * @stable
 */
@NgModule({
  imports: [
    // import your custom modules here
    TextMaskModule,
    SharedModule,
    CoreComponentsModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatTabsModule,
    MatTableModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatStepperModule,
    MatExpansionModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    MatMenuModule,
    MatRadioModule,
    ComponentsModule,
    ClienteModule,
    MatAutocompleteModule,
    MatSortModule,
    MatPaginatorModule
  ],

  entryComponents: [
    MasterVisualizarClienteComponent,
    DialogCreateUser,
    MasterVisualizarPerfilComponent,
    MasterVisualizarPerfilPermissoesComponent,
    MasterVisualizarPerfilUsuariosComponent,
    TableCreateProfile,
    TableConfirmUsers,
    TablePerfilAcesso,
    CriarGruposDeInvestimentoComponent,
    MasterHomCreateProfileComponent,
    TableAssociateProfileUser,
    EditarGrupoDeInvestimentoComponent,
    MasterConsultaFundosComponent,
    MasterMensagemDeletarComponent,
    MasterMensagemDuplicarComponent,
    CriarGruposDeInvestimentoComponent,
    MasterEditarPerfilAcessoComponent,
    MasterEditarPerfilDuplicacaoComponent,
    MasterEditarPerfilCancelamentoComponent,
    MasterClienteVisualizarClienteComponent,
  ],

  declarations: [
    // declare your custom components here
    DialogCreateUser,
    MasterVisualizarClienteComponent,
    MasterBOConsultaProfileComponent,
    MasterTableProfile,
    TableProfile2,
    MasterVisualizarPerfilComponent,
    MasterVisualizarPerfilPermissoesComponent,
    MasterVisualizarPerfilUsuariosComponent,
    MasterCreateProfileComponent,
    TableCreateProfile,
    MasterHomCreateProfileComponent,
    MasterCreateProfileUsersComponent,
    TableConfirmUsers,
    MasterConsultaProfileComponent,
    MasterVisualizarPerfilComponent,
    TablePerfilAcesso,
    CriarGruposDeInvestimentoComponent,
    TableAssociateProfileUser,
    TablePerfilAcesso,
    MasterClienteConsultaUsuarios,
    EditarGrupoDeInvestimentoComponent,
    MasterConsultaGruposComponent,
    MasterMensagemDeletarComponent,
    MasterMensagemDuplicarComponent,
    MasterEditarPerfilAcessoComponent,
    MasterEditarPerfilDuplicacaoComponent,
    MasterEditarPerfilCancelamentoComponent,
    MasterBoPerfilAcessoComponent,
    MasterBoTablePerfilAcesso,
    MasterConsultaFundosComponent
  ],

  exports: [
    // export the needed components here
    TextMaskModule,
    MatCheckboxModule,
    MatTabsModule,
    MatTableModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatDialogModule,
    MatSelectModule,
    MatButtonModule,
    MatStepperModule,
    MatExpansionModule,
    MatIconModule,
    MasterBOConsultaProfileComponent,
    MatMenuModule,
    ComponentsModule,
    MatRadioModule,
    MasterCreateProfileComponent,
    MasterHomCreateProfileComponent,
    MasterCreateProfileUsersComponent,
    MasterConsultaProfileComponent,
    MasterVisualizarPerfilComponent,
    TableCreateProfile,
    TablePerfilAcesso,
    CriarGruposDeInvestimentoComponent,
    MasterClienteConsultaUsuarios,
    EditarGrupoDeInvestimentoComponent,
    MasterConsultaFundosComponent,
    MasterMensagemDeletarComponent,
    MasterMensagemDuplicarComponent,
    MasterConsultaGruposComponent,
    CriarGruposDeInvestimentoComponent,
    MasterEditarPerfilAcessoComponent,
    MasterEditarPerfilDuplicacaoComponent,
    MasterEditarPerfilCancelamentoComponent,
    MasterBoPerfilAcessoComponent,
    MasterBoTablePerfilAcesso,
    MatAutocompleteModule,
  ],
  providers: [
    MasterVisualizarClienteService,
    MasterHomeCreateProfileService,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
  ],
})
export class CustomMasterModule { }
